/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestChainlinkAggregator extends Contract<ITestChainlinkAggregator> {
  latestRoundData: Call<() => { roundId_: BigNumber, answer_: BigNumber, startedAt_: BigNumber, updatedAt_: BigNumber, answeredInRound_: BigNumber }, ITestChainlinkAggregator>
  'latestRoundData()': Call<() => { roundId_: BigNumber, answer_: BigNumber, startedAt_: BigNumber, updatedAt_: BigNumber, answeredInRound_: BigNumber }, ITestChainlinkAggregator>
}

let ITestChainlinkAggregatorBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestChainlinkAggregatorBytecode = '0x';
}

// prettier-ignore
export const ITestChainlinkAggregator = contract<ITestChainlinkAggregator>(ITestChainlinkAggregatorBytecode)`
  function latestRoundData() view returns (uint80 roundId_, int256 answer_, uint256 startedAt_, uint256 updatedAt_, uint80 answeredInRound_)
`;